export const useBreadCrumbs = () => {
  const route = useRoute()
  const crumbs = []
  route.matched.forEach((item, i, { length }) => {
    const crumb = {}
    crumb.href = item.name
    crumb.title = item.meta.title
    crumb.disabled = false
    if (i === length - 1) {
      crumb.disabled = true
      crumb.active = true
    }
    crumbs.push(crumb)
  })
  return crumbs
}